import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import { useLoaMedicalTestContext } from "../../../Contexts/LoaMedicalTestContext";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { truncateStr } from "../../../utilities/helper";
import FilePreview from "./FilePreview";
import PropTypes from "prop-types";

function Summary() {
  const {
    setViewModalShown,
    setBase64File,
    formData,
  } = useLoaMedicalTestContext();

  const handleView = () => {
    const reader = new FileReader();
    reader.onloadend = () => {
      setViewModalShown(true);
      setBase64File(reader.result);
    };
    reader.readAsDataURL(formData.attachment);
  };

  return (
    <div className="p-4">
      <p className="text-[#1F2328] text-xl font-bold mb-1">
        LOA request summary
      </p>
      <p className="text-[#60656D] mb-4">
        The LOA is valid for 3 days. Review your LOA request details.
      </p>
      <div className="mb-2">
        <p className="font-semibold mb-1">Hospital name</p>
        <p className="capitalize">
          {formData.hospitalName.providerName.toLowerCase()}
        </p>
      </div>
      <div className="mb-2">
        <p className="font-semibold mb-1">Name of requesting Doctor</p>
        <p className="capitalize">
          {formData.requestingDoctorName.Physician?.split(
            ":"
          )[0].toLowerCase() || ""}
        </p>
      </div>
      <div className="mb-2">
        <p className="font-semibold mb-1">Procedures</p>
        <p>{formData.procedures.map((obj) => obj.procedureName).join(", ")}</p>
      </div>
      <div className="mb-2">
        <p className="font-semibold mb-1">Diagnosis</p>
        <p className="capitalize">
          {formData.diagnosis.icdDescription.split(":")[0].toLowerCase()}
        </p>
      </div>
      <div className="mb-2">
        <p className="font-semibold mb-1">Chief complaint</p>
        <p>{formData.chiefComplaint}</p>
      </div>
      <div className="mb-2">
        <p className="font-semibold mb-1">Doctor request</p>
        <div className="flex items-center border rounded-md p-2">
          <p className="mr-2 text-[#60656D]">
            <InsertDriveFileOutlinedIcon />
          </p>
          <p className="mr-2">{truncateStr(formData.attachment.name)}</p>
          <button className="ml-auto text-[#60656D]" onClick={handleView}>
            <VisibilityOutlinedIcon />
          </button>
        </div>
      </div>
      <FilePreview />
    </div>
  );
}

Summary.propTypes = {
  formData: PropTypes.shape({
    hospitalName: PropTypes.shape({
      providerName: PropTypes.string.isRequired,
    }).isRequired,
    requestingDoctorName: PropTypes.shape({
      Physician: PropTypes.string.isRequired,
    }).isRequired,
    procedures: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
      })
    ).isRequired,
    diagnosis: PropTypes.shape({
      icdDescription: PropTypes.string.isRequired,
    }).isRequired,
    chiefComplaint: PropTypes.string,
    attachment: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default Summary;
